module.exports = __webpack_public_path__ + "static/img/pMRI3.d7312177.png";